import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function EmptyState({ icon, title, action, className, children, ...rest }) {
    return (_jsxs("div", { className: cn("fwfa-empty-state", className), ...rest, children: [icon, title !== undefined && _jsx("h3", { children: title }), children, action] }));
}
//# sourceMappingURL=EmptyState.js.map